import { Avatar, Button, Dropdown, Navbar } from "flowbite-react";
import React from "react";
import logo from '../../Media/logo.svg'

const Header = () => {
  return (
    <Navbar
  fluid={true}
  rounded={false}
  className='bg-gray-900'
>
  <Navbar.Brand href="https://flowbite.com/">
  <img
      src={logo}
      className="mr-3 h-6 sm:h-9 py-1"
      alt="Flowbite Logo"
    />
  </Navbar.Brand>
  <div className="flex md:order-2">
    <Dropdown
      arrowIcon={false}
      inline={true}
      label={<Avatar alt="User settings" className="mr-2" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded={true}/>}
    >
      <Dropdown.Header>
        <span className="block text-sm">
          Bonnie Green
        </span>
        <span className="block truncate text-sm font-medium">
          name@flowbite.com
        </span>
      </Dropdown.Header>
      <Dropdown.Item>
        Dashboard
      </Dropdown.Item>
      <Dropdown.Item>
        Settings
      </Dropdown.Item>
      <Dropdown.Item>
        Earnings
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item>
        Sign out
      </Dropdown.Item>
    </Dropdown>
    <Navbar.Toggle />
  </div>
  <Navbar.Collapse>
    <Navbar.Link
      href="/navbars"
      active={true}
    >
      Home
    </Navbar.Link>
    <Navbar.Link href="/navbars">
      <span className="text-white">About</span>
    </Navbar.Link>
    <Navbar.Link href="/navbars">
      <span className="text-white">Services</span>
    </Navbar.Link>
    <Navbar.Link href="/navbars">
      <span className="text-white">Pricing</span>
    </Navbar.Link>
    <Navbar.Link href="/navbars">
      <span className="text-white">Contact</span>
    </Navbar.Link>
  </Navbar.Collapse>
</Navbar>
  );
};

export default Header;
